import React, { forwardRef, useMemo } from 'react'
import { FieldTypes } from 'utils/formUtils';
import ApiiroMappingForm from './ApiiroMappingForm';
import { urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function ApiiroCredentialForm(props, ref) {
    const fields = useMemo(() => {
        return [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator]
        },
         {
            name: "apiToken",
            label: "Api Token",
            required: true,
            type: FieldTypes.PASSWORD
        }]
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={ApiiroMappingForm}
            initialValue={{ apiEndpoint: 'https://app.apiiro.com/rest-api/v1' }}
        />
    )
}

export default forwardRef(ApiiroCredentialForm);